module.exports = __webpack_public_path__ + "assets/img/cancel.3dd00003.png";